import { render, staticRenderFns } from "./accountPermission.vue?vue&type=template&id=60f760ca&"
import script from "./accountPermission.vue?vue&type=script&lang=js&"
export * from "./accountPermission.vue?vue&type=script&lang=js&"
import style0 from "./accountPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports